/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeSetupModeArmedDto,
  ApiEnvelopeSetupModeCancelDto,
  ApiEnvelopeSetupModePendingDto,
  SetupModeArmRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type setupModeArmResponse200 = {
  data: ApiEnvelopeSetupModeArmedDto
  status: 200
}

export type setupModeArmResponse400 = {
  data: ApiEnvelopeSetupModeArmedDto
  status: 400
}

export type setupModeArmResponse401 = {
  data: ApiEnvelopeSetupModeArmedDto
  status: 401
}

export type setupModeArmResponseSuccess = (setupModeArmResponse200) & {
  headers: Headers;
};
export type setupModeArmResponseError = (setupModeArmResponse400 | setupModeArmResponse401) & {
  headers: Headers;
};

export type setupModeArmResponse = (setupModeArmResponseSuccess | setupModeArmResponseError)

export const getSetupModeArmUrl = () => {




  return `/api/setup-mode/arm`
}

export const useSetupModeArmHook = (): (setupModeArmRequest?: SetupModeArmRequest, options?: RequestInit) => Promise<setupModeArmResponse> => {

      const customFetcher = useSfetchMutator();
      return (setupModeArmRequest?: SetupModeArmRequest, options?: RequestInit) => {

        return customFetcher(getSetupModeArmUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setupModeArmRequest)
  }
);
      }
  }


export type setupModeCancelResponse200 = {
  data: ApiEnvelopeSetupModeCancelDto
  status: 200
}

export type setupModeCancelResponse401 = {
  data: ApiEnvelopeSetupModeCancelDto
  status: 401
}

export type setupModeCancelResponseSuccess = (setupModeCancelResponse200) & {
  headers: Headers;
};
export type setupModeCancelResponseError = (setupModeCancelResponse401) & {
  headers: Headers;
};

export type setupModeCancelResponse = (setupModeCancelResponseSuccess | setupModeCancelResponseError)

export const getSetupModeCancelUrl = () => {




  return `/api/setup-mode/cancel`
}

export const useSetupModeCancelHook = (): ( options?: RequestInit) => Promise<setupModeCancelResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSetupModeCancelUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type setupModePendingResponse200 = {
  data: ApiEnvelopeSetupModePendingDto
  status: 200
}

export type setupModePendingResponse401 = {
  data: ApiEnvelopeSetupModePendingDto
  status: 401
}

export type setupModePendingResponseSuccess = (setupModePendingResponse200) & {
  headers: Headers;
};
export type setupModePendingResponseError = (setupModePendingResponse401) & {
  headers: Headers;
};

export type setupModePendingResponse = (setupModePendingResponseSuccess | setupModePendingResponseError)

export const getSetupModePendingUrl = () => {




  return `/api/setup-mode/pending`
}

export const useSetupModePendingHook = (): ( options?: RequestInit) => Promise<setupModePendingResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSetupModePendingUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


